import axios from 'axios';

function getUsersForClient (clientId) {
  return axios.get('api/users/' + clientId);
}

function getUserById (userId) {
  return axios.get('api/user/getuser/' + userId);
}

function getAllUsers () {
  return axios.get('api/users');
}

function saveNewUsers (newUsers) {
  return axios.post('api/users', {newUsers: newUsers});
}

function deleteUser (userId) {
  return axios.delete('api/users/' + userId);
}

function updateUser (user) {
  return axios.put('api/users', {user: user});
}

function updateUserForClient (user) {
  return axios.put('api/updateUserForClient', {user: user});
}

export {
  getUsersForClient,
  getAllUsers,
  saveNewUsers,
  deleteUser,
  updateUser,
  getUserById,
  updateUserForClient
};



// WEBPACK FOOTER //
// ./src/services/UserService.js